import 'aws-amplify/auth/enable-oauth-listener';
import 'ag-grid-enterprise';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { CoreModule } from 'app/core/core.module';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AgGridModule } from 'ag-grid-angular';
import { Amplify } from "aws-amplify";
import { environment } from 'environments/environment';
import { ApolloModule } from 'apollo-angular';
import { appConfig } from './app.config';
import { getLocaleUserInfo } from './shared/common/utils/CustomDateAdapter';
import { FullScreenLoading } from './shared/components/full-screen-loading/full-screen-loading';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { FullscreenOverlayContainer, OverlayContainer } from '@angular/cdk/overlay';
import { HttpClientModule } from '@angular/common/http';
import { TranslocoModule } from '@ngneat/transloco';

Amplify.configure(environment.aws_cognito);

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        AgGridModule,
        BrowserModule,
        RouterModule,
        MatSnackBarModule,
        ApolloModule,
        FuseModule,
        CoreModule,
        LayoutModule,
        FullScreenLoading,
        HttpClientModule,
        TranslocoModule
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        ...appConfig.providers,
        ...getLocaleUserInfo(),
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: <MatDialogConfig>{
                autoFocus: false
            }
        },
        {
            provide: OverlayContainer,
            useClass: FullscreenOverlayContainer
        }
    ]
})
export class AppModule {
}
